import React, { useContext } from "react";
import styled, { keyframes } from "styled-components";
import { AppContext } from "../context/AppContext";

const slideDown = keyframes`
  from { transform: translateY(-60px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
`;

const AlertWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: linear-gradient(90deg, #00b894, #00cec9);
  color: #fff;
  text-align: center;
  padding: 14px 0;
  z-index: 9999;
  animation: ${slideDown} 0.35s ease forwards;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
`;

const Message = styled.span`
  font-weight: 600;
  margin-right: 1rem;
`;

const CloseBtn = styled.button`
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 6px 12px;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.2s;
  &:hover {
    background: rgba(255, 255, 255, 0.35);
  }
`;

export default function GlobalAlert() {
  const { alertMessage, clearGlobalAlert } = useContext(AppContext);

  if (!alertMessage) return null;

  return (
    <AlertWrapper>
      <Message>{alertMessage}</Message>
      <CloseBtn onClick={clearGlobalAlert}>Close</CloseBtn>
    </AlertWrapper>
  );
}
